// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:09:10+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            bf458d23a960ae21c7a1e56439d19a05
//    Signature:      eyJpdiI6ImdYeTlMT2lkcTJiU1JlSE5KQWFkXC9BPT0iLCJ2YWx1ZSI6Ikd6ZmNTS1wvbTBoc2I5WkRGXC9tV3NWXC9RRHZpTVRpTHc5T3htTUJLVE4zaGNzYlBzTkg3ZW0wdkZhaWFHMEozM0hLNXZFTFI0NXVuTnBnYmwrQXNxSkdRZTFZRzFwcTFhZzg5QmY2M1B4UlNERUFMaTJLbExrdXMyU29QT09rTjBjXC9UMGJtamhoc0VZXC9hVDFYVXNWclBYRlwvRjRJNHVsRkxpUVwvdXBydkU3Rk9VZWZwVlcyOGNFQTJHT1hcL28wWWZKenNHdHpNQ3RpTlQ3ajNybVwvbHlucUlMWStrWXgrMHpGQnN0MjlYeTIzVTdWYnlyZTMrR1RnNDBROHA3NDZQeGhHRTRJV0hia2dTXC80V2FPXC9HV3dyTEw2SnR6ZmtFdlorZ1wvTnhJVlpOck1TYytNdWM2emJ6bW5SQWJYMCtqcjJSQnk2YjRWdTJ4TDZ2c2d6YWVhb1wvYVVJS0lzZCs2Tlo4eDlcL1YrSndUdVwvVzdiQjBVYW84YXJLQTlhYThTaWI3b2RTUklZNjBRR0d1UjdSakJqeStqU2c9PSIsIm1hYyI6ImZmYzRjMjdmM2RkMWFiYjU3OTZiN2M1Y2E0NjBkODJlOTQ4NmM4MDFkODQ1ZDg3ZTExNDRiNDNmZWM4N2NkMWIifQ==
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}
